import { usePlayer } from "@/contexts/PlayerContext";
import { fileUrl } from "@/lib/api";
import { Play, Pause } from "lucide-react";

function fmt(t) {
  if (!isFinite(t) || t <= 0) return "00:00";
  const m = Math.floor(t / 60);
  const s = Math.floor(t % 60);
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export default function AudioPlayer() {
  const { track, playing, progress, duration, toggle, seek } = usePlayer();
  if (!track) return null;
  const pct = duration ? (progress / duration) * 100 : 0;

  return (
    <div
      data-testid="audio-player"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-background/95 backdrop-blur-xl"
    >
      <div className="px-4 md:px-8 py-3 flex items-center gap-4">
        <div className="w-12 h-12 border border-border bg-muted overflow-hidden shrink-0">
          {track.cover_path ? (
            <img src={fileUrl(track.cover_path)} alt="" className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="eq-bar" /><span className="eq-bar" /><span className="eq-bar" /><span className="eq-bar" />
            </div>
          )}
        </div>
        <button
          data-testid="player-toggle-btn"
          onClick={toggle}
          className="w-10 h-10 border border-foreground flex items-center justify-center hover:bg-primary hover:border-primary hover:text-white transition-colors"
          aria-label={playing ? "Pause" : "Play"}
        >
          {playing ? <Pause size={16} /> : <Play size={16} />}
        </button>
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-3">
            <p className="font-display text-base truncate">{track.title}</p>
            <span className="font-mono-acc text-[10px] text-muted-foreground truncate">@{track.username}</span>
          </div>
          <div
            className="mt-2 h-1 bg-muted cursor-pointer relative"
            onClick={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              seek((e.clientX - rect.left) / rect.width);
            }}
          >
            <div className="absolute inset-y-0 left-0 bg-primary" style={{ width: `${pct}%` }} />
          </div>
        </div>
        <div className="font-mono-acc text-[10px] text-muted-foreground hidden sm:flex gap-2 shrink-0">
          <span data-testid="player-current-time">{fmt(progress)}</span>
          <span>/</span>
          <span>{fmt(duration)}</span>
        </div>
      </div>
    </div>
  );
}
